module.exports = __webpack_public_path__ + "img/menu.a4566700.svg";